import axios from 'axios';
import Rest from 'services/data/rest';
import Promise from 'bluebird';

// Utils
import { formatFileUploadFormData } from 'utils/form-utils';


class ExpenseBill extends Rest {
  static path = 'expenseBill';

  static create(expenseBill) {
    return Promise.resolve(axios.post('/api/expenseBill', formatFileUploadFormData(expenseBill, ['receipt'])))
      .tap(this.logRequest);
  }

  static check() {
    return Promise.resolve(axios.post('/api/expenseBill/check'))
      .tap(this.logRequest);
  }

  static update(expenseBill) {
    return Promise.resolve(axios.put(`/api/expenseBill/${expenseBill.id}`, formatFileUploadFormData(expenseBill, ['receipt'])))
      .tap(this.logRequest);
  }
}

// Exports
export default ExpenseBill;
